import { QueryClient } from '@tanstack/vue-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
    mutations: { retry: 0 },
  },
})

export const CARS_LIST_QUERY_KEY = 'cars-list'
export const CARS_DETAIL_QUERY_KEY = 'cars'

export const MESSAGES_UNREAD_QUERY_KEY = 'messages-unread-count'
export const MESSAGES_LIST_QUERY_KEY = 'messages-list'
export const MESSAGE_CHANNELS_QUERY_KEY = 'message-channels'
export const MESSAGE_SETTINGS_QUERY_KEY = 'message-settings'

export function invalidateCarsQueries(client = queryClient) {
  return Promise.all([
    client.invalidateQueries({ queryKey: [CARS_LIST_QUERY_KEY] }),
    client.invalidateQueries({ queryKey: [CARS_DETAIL_QUERY_KEY] }),
  ])
}

export function invalidateCarDetail(carId, client = queryClient) {
  const id = Number(carId)
  if (!Number.isFinite(id) || id < 1) {
    return client.invalidateQueries({ queryKey: [CARS_DETAIL_QUERY_KEY] })
  }
  return Promise.all([
    client.invalidateQueries({ queryKey: [CARS_DETAIL_QUERY_KEY, id] }),
    client.invalidateQueries({ queryKey: [CARS_LIST_QUERY_KEY] }),
  ])
}

export function invalidateMessageQueries(client = queryClient) {
  return Promise.all([
    client.invalidateQueries({ queryKey: [MESSAGES_UNREAD_QUERY_KEY] }),
    client.invalidateQueries({ queryKey: [MESSAGES_LIST_QUERY_KEY] }),
    client.invalidateQueries({ queryKey: [MESSAGE_CHANNELS_QUERY_KEY] }),
    client.invalidateQueries({ queryKey: [MESSAGE_SETTINGS_QUERY_KEY] }),
  ])
}
